import React from 'react';
import { useApi, useActions } from '../../common/minifield';
import DataRegistry from './data-registry';

import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Spinner } from '../../common/components/spinner';
import { If } from '../../common/tools/jsx-helper';

import { useAccountCache } from '../account/account-cache';

const DataViewer = ({ namespace, type, id }) => {
	const api = useApi();
	const [data, setData] = React.useState();
	
	React.useEffect(() => {		
		api.get('/admin/data/view', { namespace, type, id }).then(result => setData(result));
	}, [api, namespace, type, id]);	
	
	return data ? DataRegistry[type](data) : <Spinner />;
};
export { DataViewer };

const GeneralDataProperties = ({ data }) => {
	const accounts = useAccountCache({ namespace: data.namespace });
	const action = useActions();
	const [owner, setOwner] = React.useState();
	
	React.useEffect(() => {
		if (accounts) {
			const account = accounts.find(x => x.badge === data.badge);
			if (account) {
				setOwner(account.name);
			}
		}
	}, [data, accounts]);
	
	return (
		<div className="pt-3">
			<div className="form-group mb-2">
				<label className="form-label">Id</label>
				<input type='text' className="form-control" value={ data.id } readOnly />
			</div>
			<div className="form-group mb-2 row">
				<div className="col">
					<label className="form-label">Type</label>
					<input type='text' className="form-control" value={ data.type } readOnly />
				</div>				
				<If condition={ data.properties?.status }><div className="col">
					<label className="form-label">Status</label>
					<input type='text' className="form-control" value={ data.properties?.status } readOnly />
				</div></If>
			</div>
			<div className='form-group mb-2'>
				<label className='form-label'>Namespace</label>
				<input type='text' className='form-control' value={ data.namespace } readOnly />
			</div>
			<If condition={ 'badge' in data }>
				<div className='form-group mb-2'>
					<label className='form-label'>Owner</label>
					<div className="d-flex align-items-center">
						<input type='text' className='form-control' value={ owner } readOnly />
						<button type="button" className="btn btn-sm btn-dark ms-2" onClick={ (event) => action({ action: 'account-view', payload: { namespace: data.namespace, badge: data.badge } }) } ><FontAwesomeIcon icon="fa-solid fa-user" /></button>
					</div>
				</div>
			</If>
			<If condition={ 'creationDate' in data }>
				<div className='row'>
					<div className='form-group mb-2 col'>
						<label className='form-label'>Creation date</label>
						<input type='text' className='form-control' value={ moment.utc(data.creationDate).format('dddd, DD/MM/yyyy HH:mm') } readOnly />
					</div>
					<div className='form-group mb-2 col'>
						<label className='form-label'>Modification date</label>
						<input type='text' className='form-control' value={ moment.utc(data.modificationDate).format('dddd, DD/MM/yyyy HH:mm') } readOnly />
					</div>
				</div>
			</If>
			<div className="form-group">
				<label className="form-label">Properties</label>
				<div className="form-control">
					<div className="row">
						<div className="col-4"><strong>Key</strong></div><div className="col-8"><strong>Value</strong></div>				
					</div>
					{
						Object.entries(data.properties).map(([key, value]) => <div className="row" key={ key }><div className="col-4">{ key }</div><div className="col-8 text-break">{ JSON.stringify(value) }</div></div>)
					}
				</div>
			</div>
		</div>
	);
};
export { GeneralDataProperties };